import reducer from './reducers';

import * as teacherActions from './actions';

export {
  teacherActions,
};

export default reducer;
